import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sera-icon',
    templateUrl: './sera-icon.component.html',
    styleUrls: ['./sera-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraIconComponent {
    constructor() {}

    @Input()
    class!: string;

    @Input()
    tooltipKey: string = '';
}
